import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#date-formats" }),
  /*#__PURE__*/_createTextVNode(" Date Formats ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, "format"),
  /*#__PURE__*/_createTextVNode(" to control displayed text's format in the input box."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" By default, the component accepts and emits a "),
  /*#__PURE__*/_createVNode("code", null, "Date"),
  /*#__PURE__*/_createTextVNode(" object."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Check the list here of all available formats of Day.js."),
  /*#__PURE__*/_createVNode("br")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "Emits Date object", -1)
const _hoisted_7 = { class: "demonstration" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, "Value: " + _toDisplayString(_ctx.value1), 1),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
          type: "date",
          placeholder: "Pick a Date",
          format: "YYYY/MM/DD"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}